import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { SalaryDetails } from "../../Models/Marketer";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class SalariesTableVM extends InterActive{
    private id:string= ''
    private list:SalaryDetails[] = []
    private more:boolean = true

    public get Data():SalaryDetails[] { return this.list}
    public get More():boolean { return this.more}

    constructor(id:string){
        super()
        this.id = id
    }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.marketerSalariesList(this.id)
                    if(response){
                        if(response.status ===  HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length === 0){ this.Messege = 'لا توجد بيانات'; this.more = false }
                                else {
                                    this.list = response.data.data;
                                    this.update()
                                }
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch {  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }
    public async addData(){
                try{
                    const response = await ApiRequest.marketerSalariesList(this.id, this.list[this.list.length-1].id)
                    if(response){
                        if(response.status ===  HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length === 0){this.more = false }
                                else {
                                    this.list =[...this.list, ...response.data.data];
                                    this.update()
                                }
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch {  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }

}